import * as React from 'react';
import styled, {css} from 'styled-components'
import {AppNotificationType} from "../../../domain/model/app_notification_message";
import {ConstColor} from "../../../config/styles_const/styles_const";

interface IProps
    extends React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLDivElement>,
        HTMLDivElement
        > {
    appNotificationType: AppNotificationType
}

const AppNotificationWrapper: React.FC<IProps> = (props) => {

    const {ref, appNotificationType, ...DivProps} = props;

    return <Notification {...DivProps} appNotificationType={appNotificationType} />

};

export default AppNotificationWrapper;

const Notification = styled.div<{ appNotificationType: AppNotificationType }>`
    margin-bottom: 1px;
    height: 60px;
    display: flex;
    align-items: center; 
    justify-content: center;
    ${props => props.appNotificationType === AppNotificationType.INFO && css`
        color: #ffffff;
        background-color: ${ConstColor.NoticeInfo};
    `}
    ${props => props.appNotificationType === AppNotificationType.WARN && css`
        color: #1d1d1d;
        background-color: ${ConstColor.NoticeWarn};
    `}
    ${props => props.appNotificationType === AppNotificationType.ERROR && css`
        color: #ffffff;
        background-color: ${ConstColor.NoticeError};
    `}
    animation:show 1s both;
    
    @keyframes show {
        0% {
            opacity: 0; 
            transform: translate3d(0,-20px,0);
        }
        100% {
            opacity: 1; 
            transform: translate3d(0,0,0);
        }
    }
`;




// WEBPACK FOOTER //
// ./src/presentation/common/atom/app_notification_wrapper.tsx